import {
  LIBRARIES_EXPORT,
  LIST_LIBRARY_URL,
  LIBRARY_SUMMARY_URL,
  LIBRARYS_TEMPLATE,
  LIBRARY_BY_ID,
  UPDATE_LIBRARY_BY_ID,
  DELETE_LIBRARY_BY_ID_V1,
  CREATE_LIBRARY,
  CREATE_ALL_OUTLET_LIBRARY,
  INGREDIENT_WITH_UNCATEGORY,
  LIBRARY_GET_UNITS,
  INGREDIENT_CREATE_CATEGORY
} from './constants'

const resolve = response => {
  return Promise.resolve(response)
}

const reject = error => {
  let eobj
  if (error.response) {
    let data = error.response.data
    if (data.errors) {
      eobj = new Error(data.errors)
    } else if (data.message) {
      eobj = new Error(data.message)
    } else {
      eobj = new Error(error.message)
    }
  } else {
    eobj = new Error(error.message)
  }
  return Promise.reject(eobj)
}

export function getExportLibrary (params) {
  return axios.get(LIBRARIES_EXPORT, {params, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message))
    })
}

export function getUnits () {
  return axios.get(LIBRARY_GET_UNITS, {withCredentials: true})
    .then((response) => {
      return Promise.resolve(response.data)
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message))
    })
}

export function getCategoriesWithUncategorized () {
  return axios.get(INGREDIENT_WITH_UNCATEGORY, {withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message))
    })
}

export function getLibraryTemplate () {
  return axios.get(LIBRARYS_TEMPLATE, {withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message))
    })
}

export function getLibraries (queryparams) {
  return axios
    .get(LIST_LIBRARY_URL, {params: queryparams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response.data.results)
    }).catch(error => {
      // TODO low show the error message maybe?
      if (error.response) {
        let obj = new Error(new Error(error.message))
        obj.status = error.response.status
        return Promise.reject(obj)
      } else {
        return Promise.reject(new Error(error.message))
      }
    })
}

export function getLibraryById (id, queryparams) {
  return axios
    .get(LIBRARY_BY_ID(id), {params: queryparams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response.data)
    }).catch(error => {
      // TODO low show the error message maybe?
      if (error.response) {
        let obj = new Error(new Error(error.message))
        obj.status = error.response.status
        return Promise.reject(obj)
      } else {
        return Promise.reject(new Error(error.message))
      }
    })
}

export function getSummary (queryParams) {
  return axios
    .get(LIBRARY_SUMMARY_URL, {params: queryParams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}

export function putLibraryById (id, data, params) {
  return axios
    .put(LIBRARY_BY_ID(id), data, {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

export function postLibrary (data, params) {
  return axios
    .post(CREATE_LIBRARY, data, {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

export function postCreateAllOutletLibrary (data, params) {
  return axios
    .post(CREATE_ALL_OUTLET_LIBRARY, data, {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

export function updateImageById (id, data, params) {
  return axios
    .put(UPDATE_LIBRARY_BY_ID(id), data, {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

export function deleteLibraryByIdV1 (id, params) {
  return axios
    .delete(DELETE_LIBRARY_BY_ID_V1(id), {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

export function createIngredientCategory (data) {
  return axios
    .post(INGREDIENT_CREATE_CATEGORY, data, {withCredentials: true})
    .then(resolve)
    .catch(reject)
}



// WEBPACK FOOTER //
// ./app/api/ingredients/library/library.js